import ApiService from '../../services/apiService';
import { EventBus } from '../../services/eventbus.js';
import { flattenAccountsTree, getParents } from '../../utils/treeviewHelper';
import { mapState, mapGetters } from 'vuex';
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'ViewAccountMgmtAccountMgmtOverview',
  props: {
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      tabItems: [],
      tabItem: null,
      isApiKeysVisible: false,
      accountsFilterEmpty: false,
      active: [],
      open: [],
      tenantSearch: null,
      tenantCreateDialog: false,
      tenantDeleteDialog: false,
      tenantDeleteId: -1,
      hasTenantManagePermission: false,
      tenants: [],
      tenantsList: [],
      selectedTenant: null,
      userSearch: null,
      usersIncludeAncestorAdmins: false,
      usersIncludeSubAccounts: false,
      apiKeySearch: null,
      apiKeysIncludeAncestorAdmins: false,
      apiKeysIncludeSubAccounts: false,
      tableLoading: false,
      currentMode: 'create',
      requiredRule: [v => !!v || this.$i18n_t('Common.fieldRequired')],
      itemsLoadMore: false,
      isDialogCreateUserOpen: false,
      counter: 0
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions', 'openedTreeview']),
    ...mapGetters({
      sessionAccess: 'authentication/access',
      sessionPrimaryTenantIds: 'authentication/primaryTenantIds',
      sessionUserId: 'authentication/userId'
    }),
    hasAdminPermissionsForSelectedTenant() {
      if ((this.selectedTenant || {}).hasAdminPermissions) {
        return true;
      }
      // in case the user has no admin-permissions, these 2 UI-options are hidden,
      // so also reset them to prevent any accidental side-effects
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.usersIncludeAncestorAdmins = false;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.usersIncludeSubAccounts = false;
      return false;
    },
    hasUserCreatePermissions() {
      return this.hasAdminPermissionsForSelectedTenant || (this.selectedTenant || {}).hasUserCreatePermissions;
    },
    userReadAccesses() {
      // find the user-accesses that have UserManagement.read permission
      return uniqBy(this.sessionAccess.filter(access => {
        return access.roles.find(role => {
          return role.Rules.find(rule => {
            return rule.subject.indexOf('UserManagement') >= 0 && rule.actions.indexOf('read') >= 0 || rule.subject.indexOf('all') >= 0 && rule.actions.indexOf('read') >= 0;
          });
        });
      }).concat(this.userManagementAccesses), access => access.scopeId);
    },
    userCreateAccesses() {
      // find the user-accesses that have UserManagement.create permission
      return uniqBy(this.sessionAccess.filter(access => {
        return access.roles.find(role => {
          return role.Rules.find(rule => {
            return rule.subject.indexOf('UserManagement') >= 0 && rule.actions.indexOf('create') >= 0;
          });
        });
      }).concat(this.userManagementAccesses), access => access.scopeId);
    },
    userManagementAccesses() {
      // find the user-accesses that have UserManagement.manage permission
      return this.sessionAccess.filter(access => {
        return access.roles.find(role => {
          return role.Rules.find(rule => {
            return rule.subject.indexOf('UserManagement') >= 0 && rule.actions.indexOf('manage') >= 0 || rule.subject.indexOf('all') >= 0 && rule.actions.indexOf('manage') >= 0;
          });
        });
      });
    },
    tenantManageIds() {
      if (!this.sessionAccess) {
        return [];
      }
      if (this.$store.state.app.permissions['all.manage.tenantIds'] !== undefined) {
        return this.$store.state.app.permissions['all.manage.tenantIds'];
      }
      // find the user-accesses that have all.manage permission
      return this.sessionAccess.filter(access => {
        return access.roles.find(role => {
          return role.Rules.find(rule => {
            return rule.subject.indexOf('all') >= 0 && rule.actions.indexOf('manage') >= 0;
          });
        });
      }).map(a => a.tenantId);
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    tenantBreadcrumPath() {
      if (this.selectedTenant && this.selectedTenant.name) {
        return this.tenantAncestorList(this.selectedTenant).map(t => {
          return {
            text: t.name,
            click: () => {
              this.changedSelectedTenant([t.id]);
            }
          };
        });
      }
      return [];
    },
    getTablePage() {
      return this.$store.state.app.tablePage;
    }
  },
  watch: {
    tenants(newVal) {
      if (newVal && newVal.length) {
        this.tenantsList = flattenAccountsTree(newVal[0]);
      }
    },
    tenantSearch: {
      handler: function (newVal, oldVal) {
        if (!newVal) {
          this.open = [];
          this.accountsFilterEmpty = false;
          return;
        }
        if (oldVal !== newVal) {
          this.openFilteredTreeNodes(this.tenantSearch || '');
          this.$nextTick(() => {
            const treeViewElement = get(this.$refs, 'accountTreeView.$children[0].$el', null);
            if (treeViewElement && treeViewElement.classList.contains('v-treeview-node--excluded')) {
              this.accountsFilterEmpty = true;
            } else {
              this.accountsFilterEmpty = false;
            }
          });
        }
      }
    },
    selectedTenant() {
      this.active = [(this.selectedTenant || {}).id].filter(t => t);
    }
  },
  mounted() {
    this.fetchAndPrepareData();
  },
  methods: {
    get,
    filterTree(item, search, textKey) {
      // eslint-disable-next-line eqeqeq
      return item[textKey].toLowerCase().indexOf(search.toLowerCase()) >= 0 || item.id == search;
    },
    // debounce by 250ms to wait for the user to finish typing
    openFilteredTreeNodes: debounce(function (filter) {
      const found = this.tenantsList.filter(item => {
        // eslint-disable-next-line eqeqeq
        return item.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0 || item.id == filter;
      });
      let ids = [];
      found.forEach(account => {
        const result = getParents(this.tenantsList, account);
        // using Set to automatically remove duplicates
        ids = [...new Set([...ids, ...result])];
      });
      this.open = Array.from(ids).sort((a, b) => a - b);
    }, 250),
    async loadMore() {
      this.$router.push({
        path: '/account-mgmt/'
      });
      await this.$store.commit('app/openedTreeview', []);
      this.itemsLoadMore = false;
      this.active = [];
      this.open = [];
      this.tenants = [];
      this.selectedTenant = null;
      await this.fetchAndPrepareData();
    },
    openTreeView() {
      let openIds = [];
      if ((this.openedTreeview || []).length) {
        // if vuex store has opened tree nodes stored, use them
        openIds = this.openedTreeview;
      } else if (this.active[0]) {
        // else if the route has an active tenant, open all its parents
        const activeTenant = this.tenantsList.filter(item => item.id === parseInt(this.active[0]));
        if (activeTenant[0]) {
          const parents = this.tenantAncestorList(activeTenant[0]);
          openIds = parents.map(item => item.id);
        }
      }
      this.open = openIds;
      this.itemsLoadMore = true;
    },
    setSelectedUserAfterCreation(payload) {
      this.refreshTenants();
      this.selectedTenant = {
        id: payload.data.id
      };
    },
    breadCrumbsPath() {
      return this.tenantBreadcrumPath;
    },
    tenantHandleSubmit() {
      this.$refs.tenantDetails.handleSubmit();
    },
    fetchAndPrepareData() {
      // the tenant can only be edited by an "admin" on a certain scope
      this.hasTenantManagePermission = this.tenantManageIds.length > 0;
      this.loadTenantsForTree().then(() => {
        if (this.$route.params.tenantId) {
          this.active = [this.$route.params.tenantId];
          if (this.$route.query.userlist !== undefined) {
            this.tabItem = 'tabUserList';
          } else {
            this.tabItem = 'tabTenantDetails';
          }
          this.openTreeView();
        }
        if (this.active.length === 0 && this.selectedTenant) {
          this.active = [this.selectedTenant.id];
        }
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.tenantReadFail'), 'error');
        }
      });
    },
    loadTenantsForTree() {
      const adminAccountsPromises = Promise.all(this.tenantManageIds.map(tenantId => {
        return ApiService.tenantGetById(tenantId, ['no-scope-descendents']);
      }));
      const otherUserReadAccesses = this.userReadAccesses.filter(access => {
        // first filter out all admin-account user-accesses
        return this.tenantManageIds.findIndex(tenantId => tenantId === access.tenantId) < 0;
      });
      const scopesPromises = Promise.all(otherUserReadAccesses.map(access => {
        return ApiService.getScope(access.scopeId);
      }));
      return Promise.all([adminAccountsPromises, scopesPromises]).then(allData => {
        const accountTree = allData[0];
        const scopes = allData[1];
        accountTree.forEach(account => {
          if (!account.data) {
            account.data = {};
          }
        });
        // for all the other accounts, first check if they are already part of the tree
        // i.e. for an account permissions were given, but an ancestor-account already has admin-permissions,
        // so that account already exists in the tree
        scopes.forEach(scope => {
          if (!this.findTenantInTreeArray(accountTree, scope.tenant.id)) {
            if (!scope.data) {
              scope.data = {};
            }
            // it may be that a user-access object is not on ACCOUNT-level, in those cases overwrite the scope-id
            // it is a little dirty, but this scopeId is used by the user/api-key list, which works seamlessly then
            scope.scopeId = scope.id;
            // `isScope` is a flag to distinguish sub-scopes from ACCOUNT-scopes
            // so all of these are scopes, but for account-scopes no distinction needs to be done
            scope.isScope = scope.tenant.scopeId !== scope.id;
            // the tenant-id is used by the user-list
            // it is ALSO displayed in the tree as ID of this "account/scope".
            // MAY cause confusion since the scope-id is different after all, but when mixing scopes and accounts,
            // at least it is consistent to always show the account-id
            scope.id = scope.tenant.id;
            accountTree.push(scope);
          }
        });
        accountTree.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
        if (!this.selectedTenant && accountTree.length > 0) {
          this.selectedTenant = accountTree[0];
        } else if (this.selectedTenant) {
          this.selectedTenant = this.findTenantInTreeArray(accountTree, this.selectedTenant.id) || this.selectedTenant;
        }
        this.checkForAdminPermissionsForSelectedTenant();
        this.tenants = accountTree;
        return accountTree;
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.tenantReadFail'), 'error');
        }
      }).finally(() => {
        this.$store.state.app.loading = false;
      });
    },
    checkForAdminPermissionsForSelectedTenant() {
      // trivial check for "root-accounts"
      if (this.tenantManageIds.findIndex(tenantId => tenantId === this.selectedTenant.id) >= 0) {
        this.selectedTenant.hasAdminPermissions = true;
        // force a UI-refresh now
        this.selectedTenant = {
          ...this.selectedTenant
        };
        return;
      }
      // further check for all sub-accounts
      ApiService.checkAccesses([{
        subject: 'all',
        action: 'manage'
      }, {
        subject: 'UserManagement',
        action: 'create'
      }], {
        scopeId: this.selectedTenant.scopeId
      }).then(res => {
        // if flagged as scope, this is not an account, so it cannot have account-admin-permissions
        this.selectedTenant.hasAdminPermissions = this.selectedTenant.isScope ? false : res['all.manage'];
        this.selectedTenant.hasUserCreatePermissions = res['UserManagement.create'];
        // force a UI-refresh now
        this.selectedTenant = {
          ...this.selectedTenant
        };
      }).catch(() => {
        this.selectedTenant.hasAdminPermissions = false;
        // force a UI-refresh now
        this.selectedTenant = {
          ...this.selectedTenant
        };
      });
    },
    addNew() {
      if (this.selectedTenant) {
        this.tenantCreateDialog = true;
      }
    },
    addNewUser() {
      if (this.selectedTenant) {
        this.isDialogCreateUserOpen = true;
      }
    },
    deleteTenant(id) {
      ApiService.tenantDelete(this, id).then(() => {
        this.$snack(this.$i18n_t('Common.tenantDeleteSuccess'), 'success');
        this.refreshTenants();
        this.tenantSearch = '';
        this.selectedTenant = this.tenants[0];
      }).catch(error => {
        console.error('Tenant delete fail', error);
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.tenantDeleteFail'), 'error');
        }
      });
    },
    userBulkcreate() {
      this.$router.push(`/account-mgmt/user-bulk-create/${this.selectedTenant.id}`);
    },
    refreshTenants() {
      this.fetchAndPrepareData();
      this.tenantCreateDialog = false;
    },
    tenantTreeIcon(tenant) {
      if (tenant.isScope) {
        return 'fal fa-key';
      }
      const hasVisibleParent = tenant.parentId && !!this.findTenantInTreeArray(this.tenants, tenant.parentId);
      return !hasVisibleParent ? 'fal fa-users' : !tenant.children || tenant.children.length === 0 ? 'fal fa-user' : 'fal fa-user-friends';
    },
    tenantTreeLabelClass(item) {
      let activeColor = this.color;
      return get(this.selectedTenant, 'id') === get(item, 'id') ? `${activeColor}--text text-bold` : '';
    },
    tenantAncestorList(tenant) {
      const findParents = t => {
        if (t && t.parentId) {
          const parent = this.findTenantInTreeArray(this.tenants, parseInt(t.parentId));
          if (parent) {
            return findParents(parent).concat([parent]);
          }
        }
        return [];
      };
      return cloneDeep(findParents(tenant).concat([tenant]));
    },
    changedSelectedTenant(tenantIds) {
      if (!tenantIds.length || !this.tenants || !this.tenants.length) {
        return;
      }
      this.selectedTenant = this.findTenantInTreeArray(this.tenants, parseInt(tenantIds[0]));
      this.checkForAdminPermissionsForSelectedTenant();
      EventBus.$emit('update-breadcrumbs');
    },
    findTenantInTreeArray(treeArray, tenantId) {
      for (let i = 0; i < treeArray.length; i++) {
        const foundTenant = this.findTenantInTree(treeArray[i], tenantId);
        if (foundTenant) {
          return foundTenant;
        }
      }
      return null;
    },
    findTenantInTree(tree, tenantId) {
      if (tree.id === tenantId) {
        return tree;
      }
      if (tree.children && tree.children.length > 0) {
        return this.findTenantInTreeArray(tree.children, tenantId);
      }
      return null;
    },
    editUser(user) {
      let openedTreeviewIds = [];
      this.tenantAncestorList(this.selectedTenant).forEach(item => {
        openedTreeviewIds.push(item.id);
      });
      this.$store.commit('app/openedTreeview', openedTreeviewIds);
      this.$router.push({
        path: `/account-mgmt/user/${this.selectedTenant.id}/${user ? user.id : ''}`
      });
    },
    createUser(data) {
      // as username, use the email. It is the same anyway
      data.username = data.email;
      const tenantId = parseInt(this.active[0]);
      ApiService.createUser(tenantId, data).then(() => {
        this.$snack(this.$i18n_t('accMgmt.user.createSuccessSnack'), 'success');
        this.closeUserDialog();
      }).catch(error => {
        if (error.response && this.$i18n_te(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('accMgmt.user.createFailedSnack'), 'error');
        }
      });
    },
    close() {
      this.tenantCreateDialog = false;
    },
    closeUserDialog() {
      this.isDialogCreateUserOpen = false;
      this.counter++;
    },
    activeItem(id) {
      this.$store.commit('app/setTablePage', 1);
      this.$router.replace({
        query: {
          active: id
        }
      });
    },
    goToConnectors() {
      this.$router.push({
        path: '/connectors/list'
      });
    }
  }
};